import React from 'react';
import { Skeleton } from '@mui/material';

const CustomizerGridItem = () => {
	return (
		<>
			<Skeleton sx={{ pt: '130%', mt: '-30%' }} animation={false} />
			<Skeleton animation={false} sx={{ width: '50%', mt: '-20%', mb: 2 }} />
		</>
	);
};

export default CustomizerGridItem;
